module.exports = __webpack_public_path__ + "img/role2.12292406.jpg";